export const PAGE_SIZE = 20;

export const paginateItems = (items, page, pageSize = PAGE_SIZE) => {
  if (!Array.isArray(items) || pageSize <= 0) return [];
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
};

export const rangeForPage = (items, page, pageSize = PAGE_SIZE) => {
  if (!Array.isArray(items) || items.length === 0 || pageSize <= 0) {
    return { start: 0, end: 0 };
  }
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize + 1;
  const end = Math.min(safePage * pageSize, items.length);
  return { start, end };
};
